import { t } from "i18next"
import { DistrictDDL } from "../../../Components/CommonDDL/DistrictDDL"
import { GenderDDL } from "../../../Components/CommonDDL/GenderDDL"
import { TalukaDDL } from "../../../Components/CommonDDL/TalukaDDL"
import { VillageDDL } from "../../../Components/CommonDDL/VillageDDL"
import '../../../theme/amchi-theme.css'

export const GrievanceAreaDetails = (props) => {
    const {
        Language,
        DistrictDDLID,
        setDistrictDDLID,
        GenderDDLID,
        setGenderDDLID,
        TalukaDDLID,
        setTalukaDDLID,
        VillageDDLID,
        setVillageDDLID,
        GrievanceField,
        setGrievanceField,
        onChange,
        UserID
    } = props

    return (
        <section className="am-card am-form-card am-rise am-rise-2">
            <div className="am-form-head">
                <span className="am-form-head-ico"><i className="fa-solid fa-map-location-dot"></i></span>
                <div>
                    <h2>{t('GrievanceRegistration.GrievanceAreaDetails')}</h2>
                    <p>तक्रार कोणत्या भागातील आहे ते निवडा</p>
                </div>
            </div>

            <div className="am-form-body">
                <div className="am-form-grid">

                    <div className="am-form-item">
                        <label className="am-label">
                            {t('GrievanceRegistration.GrievanceArea')} <span className="am-req">*</span>
                        </label>
                        <div className="am-field am-field--select">
                            <i className="fa-solid fa-city"></i>
                            <GenderDDL
                                GenderDDLID={GenderDDLID}
                                setGenderDDLID={setGenderDDLID}
                                Language={Language}
                                GroupID='1'
                                UserID={UserID}
                            />
                        </div>
                    </div>

                    <div className="am-form-item">
                        <label className="am-label">
                            {t('GrievanceRegistration.CenterName')}
                            <span className="am-opt">(ऐच्छिक)</span>
                        </label>
                        <div className="am-field">
                            <i className="fa-solid fa-hospital-user"></i>
                            <input
                                type="text"
                                placeholder={t('GrievanceRegistration.CenterName')}
                                name='CenterName'
                                value={GrievanceField.CenterName}
                                onChange={onChange}
                            />
                        </div>
                    </div>

                    <div className="am-form-item">
                        <label className="am-label">
                            {t('GrievanceRegistration.District')} <span className="am-req">*</span>
                        </label>
                        <div className="am-field am-field--select">
                            <i className="fa-solid fa-location-crosshairs"></i>
                            <DistrictDDL
                                DistrictDDLID={DistrictDDLID}
                                setDistrictDDLID={setDistrictDDLID}
                                Language={Language}
                                M_IndicatorGrievanceAreaID={GenderDDLID.ID}
                                UserID={UserID}
                            />
                        </div>
                    </div>

                    {
                        GenderDDLID.ID == 2 &&
                        <>
                            <div className="am-form-item">
                                <label className="am-label">
                                    {t('GrievanceRegistration.Taluka')}
                                </label>
                                <div className="am-field am-field--select">
                                    <i className="fa-solid fa-map-pin"></i>
                                    <TalukaDDL
                                        TalukaDDLID={TalukaDDLID}
                                        setTalukaDDLID={setTalukaDDLID}
                                        M_StateID='1'
                                        M_DistrictID={DistrictDDLID.ID}
                                        Language={Language}
                                        UserID={UserID}
                                    />
                                </div>
                            </div>

                            <div className="am-form-item">
                                <label className="am-label">
                                    {t('GrievanceRegistration.Village')}
                                </label>
                                <div className="am-field am-field--select">
                                    <i className="fa-solid fa-house-chimney"></i>
                                    <VillageDDL
                                        VillageDDLID={VillageDDLID}
                                        setVillageDDLID={setVillageDDLID}
                                        Language={Language}
                                        M_StateID='1'
                                        M_DistrictID={DistrictDDLID.ID}
                                        M_TalukaID={TalukaDDLID.ID}
                                        UserID={UserID}
                                    />
                                </div>
                            </div>
                        </>
                    }

                    <div className="am-form-item">
                        <label className="am-label">
                            {t('GrievanceRegistration.AreaName')} <span className="am-req">*</span>
                        </label>
                        <div className="am-field">
                            <i className="fa-solid fa-signs-post"></i>
                            <input
                                type="text"
                                placeholder={t('GrievanceRegistration.AreaName')}
                                name='AreaName'
                                value={GrievanceField.AreaName}
                                onChange={onChange}
                            />
                        </div>
                    </div>

                    <div className="am-form-item">
                        <label className="am-label">
                            {t('GrievanceRegistration.AreaAdress')} <span className="am-req">*</span>
                        </label>
                        <div className="am-field am-field--ta">
                            <i className="fa-solid fa-location-dot"></i>
                            <textarea
                                placeholder={t('GrievanceRegistration.AreaAdress')}
                                name='AreaAdress'
                                value={GrievanceField.AreaAdress}
                                onChange={onChange}
                            ></textarea>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}
